import React from 'react';
import LikedVideos from './LikedVideos';

const Collections: React.FC = () => (
  <div className="min-h-screen bg-meradio-cream dark:bg-bg-dark-primary">
    <LikedVideos />
  </div>
);

export default Collections;
